import React from 'react';
import './emphasizedParagraph.scss';

const EmphasizedParagraph = () => {
  return (
    <div className="emphasizedPg">
      <div className="emphasizedPg__line" />
      <div className="emphasizedPg__text">
        <p>
          Large global enterprises, government organizations, and startups all trust AWS to run
          their most important applications in the pursuit of ambitious goals. AWS and Intel have
          been pioneering cloud technology and innovating on behalf of AWS customers for over 16
          years. Whether you’re looking to improve cost efficiency and performance for enterprise
          workloads, want to maximize the value of your data using performance-optimized AI or HPC
          capabilities, or need a cloud that enables low latency possibilities at the edge—AWS and
          Intel offer workload-optimized infrastructure to meet the needs of virtually every
          application.
        </p>
      </div>
    </div>
  );
};

export default EmphasizedParagraph;
